(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeDepartureController', Controller);

    Controller.$inject = ['$scope', '$state', '$modal', 'employeeProfileService', 'eventService'];

    function Controller($scope, $state, $modal, employeeProfileService, eventService) {
        
        // Get Departure Infos
        employeeProfileService
            .getDepartureInfos($scope.employee.EmployeeID)
            .then(function (depInfos) {
                $scope.empDepartureInfos = depInfos;
            });

        // Cancel Departure
        $scope.cancelDeparture = function () {
            return employeeProfileService
                    .cancelDeparture($scope.employee.EmployeeID)
                    .then(function () {
                        $state.reload();
                    });
        };


    }
})();